export default function NotPlatform() {
  const platformProblems = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: '수수료가 붙는 순간',
      desc: '플랫폼에 수수료를 떼고 나면, 이사업체는 그 비용을 어딘가에서 메워야 합니다. 결국 이삿날 현장에서 견적이 올라가거나, 인력과 서비스 퀄리티가 내려갑니다.',
    },
    {
      icon: 'ri-user-unfollow-line',
      title: '책임지는 사람이 없다',
      desc: '플랫폼은 연결만 할 뿐입니다. 이사 당일 문제가 생겨도, 중간에 낀 플랫폼은 책임을 지지 않습니다. 업체와 고객 사이에서 책임이 흐릿해집니다.',
    },
    {
      icon: 'ri-exchange-line',
      title: '업체가 매번 바뀐다',
      desc: '플랫폼을 통하면 어떤 업체가 올지 알 수 없습니다. 경험도, 신뢰도도 검증되지 않은 팀이 고객의 소중한 짐을 담당하게 됩니다.',
    },
  ];

  const ourStrengths = [
    {
      icon: 'ri-shield-star-line',
      title: '직영팀이 처음부터 끝까지',
      desc: '접수 → 포장 → 운반 → 정리 → AS까지, 우리집 익스프레스 직영팀 하나가 모든 과정을 책임집니다. 중간에 다른 손이 닿지 않습니다.',
    },
    {
      icon: 'ri-refund-2-line',
      title: '수수료 없이 고객에게 돌려드린다',
      desc: '플랫폼 수수료가 없으니, 그 비용은 고객에게 돌아갑니다. 같은 품질이라면 더 합리적인 가격으로, 같은 가격이라면 더 나은 서비스로.',
    },
    {
      icon: 'ri-tools-line',
      title: '이사 후에도 AS 가능',
      desc: '이사 당일로 끝이 아닙니다. 직영으로 운영하기 때문에, 이사 후 문제가 생기면 바로 우리가 달려갑니다. 책임질 수 있는 이유입니다.',
    },
  ];

  return (
    <section className="py-14 md:py-24 px-4 md:px-6 bg-gray-950 text-white overflow-hidden">
      <div className="max-w-6xl mx-auto">

        {/* 헤더 */}
        <div className="text-center mb-10 md:mb-20">
          <span className="inline-block px-3 py-1.5 bg-orange-500/20 text-orange-400 text-xs font-bold tracking-widest rounded-full mb-4">
            WHY NOT PLATFORM
          </span>
          <h2 className="text-3xl md:text-5xl font-black leading-tight mb-4">
            우리는 <span className="text-orange-400 line-through decoration-2">플랫폼</span>이<br />
            아닙니다.
          </h2>
          <p className="text-gray-400 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            플랫폼은 연결해줄 뿐, 책임지지 않습니다.<br />
            우리집 익스프레스는 직접 합니다. 직접 책임집니다.
          </p>
        </div>

        {/* 비교 레이아웃 */}
        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-10 md:mb-16">

          {/* 플랫폼 문제 */}
          <div className="bg-gray-900 border border-gray-800 rounded-2xl p-5 md:p-8">
            <div className="flex items-center gap-3 mb-6 md:mb-8">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-red-500/20 text-red-400 shrink-0">
                <i className="ri-close-circle-line text-lg"></i>
              </div>
              <h3 className="text-base font-bold text-gray-300">플랫폼 이사는 이렇습니다</h3>
            </div>
            <div className="space-y-5 md:space-y-7">
              {platformProblems.map((item) => (
                <div key={item.title} className="flex gap-3 md:gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-red-500/10 text-red-400 shrink-0 mt-0.5">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-300 mb-1 text-sm">{item.title}</div>
                    <p className="text-gray-500 text-xs md:text-sm leading-6 md:leading-7">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 우리집 익스프레스 */}
          <div className="bg-teal-900/40 border border-teal-700/50 rounded-2xl p-5 md:p-8">
            <div className="flex items-center gap-3 mb-6 md:mb-8">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-teal-400/20 text-teal-400 shrink-0">
                <i className="ri-check-double-line text-lg"></i>
              </div>
              <h3 className="text-base font-bold text-teal-200">우리집 익스프레스는 다릅니다</h3>
            </div>
            <div className="space-y-5 md:space-y-7">
              {ourStrengths.map((item) => (
                <div key={item.title} className="flex gap-3 md:gap-4">
                  <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-teal-400/15 text-teal-400 shrink-0 mt-0.5">
                    <i className={`${item.icon} text-base`}></i>
                  </div>
                  <div>
                    <div className="font-semibold text-teal-100 mb-1 text-sm">{item.title}</div>
                    <p className="text-teal-200/60 text-xs md:text-sm leading-6 md:leading-7">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 강조 문구 배너 */}
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/38df4a14bb3c7ccba1b662fc9301563e.jpg"
              alt="직영 이사팀"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-gray-950/95 via-gray-950/80 to-gray-950/40"></div>
          </div>
          <div className="relative px-6 md:px-10 py-10 md:py-14">
            <p className="text-xs font-bold tracking-widest text-teal-400 mb-3 uppercase">Direct Operation Promise</p>
            <h3 className="text-xl md:text-3xl font-black text-white leading-snug mb-3 max-w-lg">
              수수료 없이 아낀 비용,<br />
              <span className="text-teal-400">전부 고객님께 돌려드립니다.</span>
            </h3>
            <p className="text-gray-400 text-xs md:text-sm leading-6 md:leading-7 max-w-md mb-6">
              플랫폼 수수료 0%, 외주 없는 직영 운영.<br />
              그 차이가 이사 당일 서비스의 질이 되고, 이사 후 AS의 속도가 됩니다.
            </p>
            <a
              href="https://talk.naver.com/profile/wfu3m6i"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-teal-500 hover:bg-teal-400 text-white px-5 py-2.5 rounded-lg font-semibold text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-file-list-3-line"></i>
              지금 무료 견적 받기
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
